import { parseScheduleRejection } from '../../../shared/lib/errors/parseScheduleRejection'

/**
 * A refused move, in one sentence a Handwerker can act on.
 *
 * The board turns these same three 409s into confirmation dialogs, because a dispatcher is allowed
 * to answer "trotzdem". Here there is nothing to answer: the move is refused and the only useful
 * thing to say is why, and that another time is needed. So the rejection collapses to text.
 *
 * The client checks the same rules before sending, so reaching this at all means the client could
 * not have known — a colleague booked the slot first, an absence landed, or the range holds
 * completed work the calendar does not draw. Saying "inzwischen" is therefore accurate rather than
 * hedging: something changed after the calendar was drawn.
 *
 * Classification is delegated rather than reimplemented — `parseScheduleRejection` applies the
 * API's own check order, so this cannot disagree with it about which of the three a 409 is.
 */
export function describeRejection(error: unknown): string {
  const rejection = parseScheduleRejection(error)

  switch (rejection?.kind) {
    case 'conflict':
      return 'Diese Zeit ist inzwischen belegt. Bitte wählen Sie eine andere Zeit.'
    case 'workingHours':
      return 'Sie arbeiten zu dieser Zeit nicht. Bitte wählen Sie eine andere Zeit.'
    case 'blockers':
      return 'Abgeschlossene Einträge blockieren diesen Zeitraum. Bitte wählen Sie eine andere Zeit.'
    default:
      // Not one of the three — a network error, a 500, an expired session mid-request.
      return 'Die Änderung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.'
  }
}
